// extracted by mini-css-extract-plugin
module.exports = {"loginPage":"login_loginPage__NAf0v","resetPassword":"login_resetPassword__3bIEZ","loginFormWrapper":"login_loginFormWrapper__2Xijj","logoutButton":"login_logoutButton__3wqDC"};